"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = exports.parse = void 0;
const strip_json_comments_1 = __importDefault(require("strip-json-comments"));
/**
 * Parses a given JSON with comments (JSONC).
 */
function parse(text) {
    const withoutComments = (0, strip_json_comments_1.default)(text);
    return JSON.parse(withoutComments);
}
exports.parse = parse;
/**
 * Stringifies a given JSON.
 */
function stringify(json) {
    return JSON.stringify(json);
}
exports.stringify = stringify;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianNvbmMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvanNvbmMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsOEVBQW9EO0FBRXBEOztHQUVHO0FBQ0gsU0FBZ0IsS0FBSyxDQUFXLElBQVk7SUFDMUMsTUFBTSxlQUFlLEdBQUcsSUFBQSw2QkFBaUIsRUFBQyxJQUFJLENBQUMsQ0FBQztJQUNoRCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsZUFBZSxDQUFDLENBQUM7QUFDckMsQ0FBQztBQUhELHNCQUdDO0FBRUQ7O0dBRUc7QUFDSCxTQUFnQixTQUFTLENBQUMsSUFBYTtJQUNyQyxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDOUIsQ0FBQztBQUZELDhCQUVDIn0=